import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useConfigService } from 'hooks/useConfigService';
import { useTableStore } from 'state/TableStore';
import { DashboardPreferences } from 'hooks/useDashboardPreferences';
import { CircularProgress, Box } from '@mui/material';

const DEFAULT_PREFERENCES: DashboardPreferences = {
    isDefaultLandingPage: false,
    thresholdLow: 20,
    thresholdHigh: 30,
    sortOrders: {},
};

export const DashboardLandingRedirect = () => {
    const [hasObservedLoading, setHasObservedLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const [isDefaultLandingPage, setIsDefaultLandingPage] = useState(false);

    const { loadingConfig } = useConfigService(
        'sticky-settings.json',
        null,
        true,
        false,
        false
    );

    const configService = useTableStore(state => state.configService);

    useEffect(() => {
        if (loadingConfig) {
            setHasObservedLoading(true);
            return;
        }

        if (hasObservedLoading) {
            const prefs: DashboardPreferences = {
                ...DEFAULT_PREFERENCES,
                ...(configService.dashboardPreferences ?? {})
            };
            setIsDefaultLandingPage(prefs.isDefaultLandingPage);
            setReady(true);
        }
    }, [loadingConfig, hasObservedLoading, configService.dashboardPreferences]);

    if (!ready) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Navigate
            to={isDefaultLandingPage ? "/app/dashboard" : "/app/transaction-summary"}
            replace
        />
    );
};